import React from 'react';
import Footer from './footer';
import Header from './header';
import './projects.css';

const projects = () => {
  return (
    <div>
      <Header />
      <div class='title-heading'>
        <h1>
          coming Soon <span class='title-heading-inverted'></span>...
        </h1>
      </div>
      <Footer />
    </div>
  );
};

export default projects;
